<template>
  <b-card>

    <div class="loading_page" v-if="loading">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left">

      <!-- Tab: information -->
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
        </template>

        <information-tab></information-tab>

      </b-tab>

      <!-- Tab: map -->
      <b-tab lazy >
        <template #title>
          <feather-icon icon="MapIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Map') }}</span>
        </template>
        <map-tab></map-tab>
      </b-tab>



      <!-- Tab: attributes -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="MapPinIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Attribute') }}</span>
        </template>
        <geofence-attribute-tab></geofence-attribute-tab>
      </b-tab>



      <!-- Action Buttons -->
      <b-button
          type="submit"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1 mt-2"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="createGeofence">
        Save Changes
      </b-button>
      <b-button
          class="mt-2"
          variant="outline-secondary"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      >
        Reset
      </b-button>


    </b-tabs>
  </b-card>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton,
} from 'bootstrap-vue'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import store from '@/store'
import geofenceStoreModule from '@/views/modules/geofence/geofenceStoreModule'
import { OrbitSpinner } from 'epic-spinners'
import useGeofenceCreate from './useGeofenceCreate'
import InformationTab from './InformationTab.vue'
import MapTab from '@/views/modules/geofence/geofence-create/MapTab'
import GeofenceAttributeTab from '@/views/modules/geofence/geofence-create/GeofenceAttributeTab'
import { GeofenceStore } from '@/app/geofence/state'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BButton,
    BAlert,
    OrbitSpinner,
    InformationTab,GeofenceAttributeTab,
    MapTab,
    BLink,

  },
  setup(props, { root }) {


    const auth = store.state.auth.userData
    const GEOFENCE_STORE = 'geofence'

    store.registerModule(GEOFENCE_STORE, GeofenceStore)

    onUnmounted(() => {
      if (store.hasModule(GEOFENCE_STORE))
        store.unregisterModule(GEOFENCE_STORE)
    })

    store.commit('geofence/updateRoot', root)

    store.dispatch(
        'geofence/fetchLists',
        auth.id
    )

    const geofenceData = computed(() => store.state.geofence.data)
    const loading = computed(() => store.state.geofence.loading)

    const createGeofence = () => {
      store.dispatch('geofence/createGeofence').then(res => {
        root.$bvToast.toast(
            root.$i18n.t("geofence created successfully"), {
              title: `Success`,
              variant: 'success',
            })
      }).catch(reason => {
        console.log(reason)
      })
    }

    // const GEOFENCE_S = 'app-geofence'
    //
    // // Register module
    // if (!store.hasModule(GEOFENCE_S))
    //   store.registerModule(GEOFENCE_S, geofenceStoreModule)
    //
    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(GEOFENCE_S))
    //     store.unregisterModule(GEOFENCE_S)
    // })
    //
    //
    // const { form, errors, addGeofence, ownersOptions, typesOptions, groupsOptions, calendarsOptions, requestStatus,
    //   contractsOptions, categoriesOptions, getTypesOptionsByCategory } = useGeofenceCreate(ctx)


    return {
      geofenceData,
      loading,
      createGeofence

      // form,
      // addGeofence,
      // ownersOptions,
      // typesOptions,
      // categoriesOptions,
      // contractsOptions,
      // groupsOptions,
      // calendarsOptions,
      // errors,
      // requestStatus,
      // getTypesOptionsByCategory

    }
  },
}
</script>

<style>

</style>
